module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-dashboard/admin-dashboard.component.scss
// module id = ./src/app/components/admin/admin-dashboard/admin-dashboard.component.scss
// module chunks = main